// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1wE2e","error":"Button_error__1gHtO","success":"Button_success__2cpEe","primary":"Button_primary__3fEv-"};